import type { VehicleAvailability } from '#domain/VehicleAvailability.ts';
import { apiV2Root } from '#store/apiV2Root.ts';

import { mapVehicleAvailability } from './adapters/vehicleAvailabilityAdapter.ts';
import { apiSchema } from './model/types.ts';
import { validateWarn } from './validateZodHelper.ts';

export type VehicleAvailabilityQuery = {
    from: string;
    to: string;
};

export const vehicleAvailabilitySlice = apiV2Root.injectEndpoints({
    endpoints: build => ({
        getVehicleAvailability: build.query<VehicleAvailability[], VehicleAvailabilityQuery>({
            query: params => ({ url: '/vehicle-availability', params }),
            providesTags: ['TOURS', 'VEHICLES'],
            transformResponse: (response, meta, arg) =>
                validateWarn(apiSchema.VehicleAvailability.array())(response, meta, arg).map(mapVehicleAvailability),
        }),
    }),
});

export const { useGetVehicleAvailabilityQuery } = vehicleAvailabilitySlice;
